import { useEffect, useRef } from 'react'
import { useUI } from '../store/ui'
import { useAccounts } from '../store/accounts'
import { Login } from '../pages/Login'

export function AddAccountModal() {
  const open        = useUI((s) => s.addAccountOpen)
  const close       = useUI((s) => s.setAddAccountOpen)
  const accountsLen = useAccounts((s) => s.accounts.length)
  const prevLen     = useRef(accountsLen)

  // Close automatically when a new account is added
  useEffect(() => {
    if (open && accountsLen > prevLen.current) close(false)
    prevLen.current = accountsLen
  }, [accountsLen, open, close])

  if (!open) return null

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/70"
      onClick={() => close(false)}
    >
      <div
        className="relative w-full max-w-sm overflow-y-auto"
        style={{ background: '#0a1426', maxHeight: '90vh', boxShadow: '0 24px 60px rgba(0,0,0,0.8)' }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between border-b border-white/5 px-4 py-2">
          <span className="text-xs font-bold text-white">add account</span>
          <button type="button" onClick={() => close(false)} className="text-ink-400 hover:text-white">✕</button>
        </div>
        <Login />
      </div>
    </div>
  )
}
